module.exports = require("core-js/modules/es.typed-array.for-each.js");